import type { ConflictRecord, SyncState } from "@/types/offline";

export const classifySyncFailure = (status: number): Extract<SyncState, "FAILED" | "CONFLICT"> => status === 409 ? "CONFLICT" : "FAILED";
export const retryBackoffSeconds = (attempts: number) => Math.min(300, 2 ** Math.min(Math.max(attempts, 1), 8));

export const preserveConflict = <T>({ draftId, entityType, entityId, localPayload, serverPayload, baseVersion, serverVersion, id = crypto.randomUUID(), detectedAt = new Date().toISOString() }: Omit<ConflictRecord<T>, "id" | "detectedAt" | "resolution"> & { id?: string; detectedAt?: string }): ConflictRecord<T> => ({
  id,
  draftId,
  entityType,
  entityId,
  localPayload: JSON.parse(JSON.stringify(localPayload)) as T,
  serverPayload: serverPayload === undefined ? undefined : JSON.parse(JSON.stringify(serverPayload)),
  baseVersion,
  serverVersion,
  detectedAt,
  resolution: "UNRESOLVED",
});
